import { render, staticRenderFns } from "./ShowCustomer.vue?vue&type=template&id=0c47e1c8"
import script from "./ShowCustomer.vue?vue&type=script&lang=js"
export * from "./ShowCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports